var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar"},[_c('a-breadcrumb',_vm._l((_vm.nav_bar_list),function(item){return _c('a-breadcrumb-item',{key:item},[_vm._v(" "+_vm._s(_vm.$t(`menu.${item}`))+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }